<template>
    <div class="vehicle-trim-complaint" @click="handleClick" @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave">
        <div class="ratings__header">
            <div class="ratings__header-text">Was this helpful?</div>
            <div class="ratings__arrow" :class="{ 'rotate': !showStars }"></div>
        </div>
        <div v-if="showStars" class="ratings__stars">
            <div :key="rating" v-for="(rating) in [1, 2, 3, 4, 5]" @mouseover="setScore(rating)"
                @mouseleave="setScore(0)" @click="sendRating(rating)">
                <i class="trimbot-review__star" :class="{ 'trimbot-review__star--filled': selectedScore >= rating }" />
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class RateTrimBotComponent extends Vue {
    @Prop({ default: 0 }) public selectedScore!: number;

    @Prop({ default: false }) public ratingSent!: boolean;

    public showStars: boolean = true;

    public hoveringAllowed: boolean = true;

    public handleClick() {
        if (this.showStars) {
            // If it's already open by click, close it and allow hover to reopen it
            this.showStars = false;
            this.hoveringAllowed = true;
        } else {
            // If it's closed or opened by hover, open it by click and disable hover
            this.showStars = true;
            this.hoveringAllowed = false;
        }
    }

    public handleMouseEnter() {
        if (this.hoveringAllowed && !this.showStars) {
            this.showStars = true;
        }
    }

    public handleMouseLeave() {
        if (this.hoveringAllowed && this.showStars) {
            this.showStars = false;
        }
    }

    public setScore(rating: number) {
        if (this.ratingSent) {
            return;
        }
        this.$emit('update:selectedScore', rating);
    }

    public sendRating(rating: number) {
        this.$emit('rate', rating);
    }
}
</script>
